import { isDefined } from '@sgme/fp';
import { useIsInternalUser } from 'hooks/useIsInternalUser';

import './style.scss';
import { asEquityUnderlying, Underlying } from 'models/underlying';

import { Row } from './row';

type Props = {
  underlyings: readonly Underlying[];

  onUnderlyingRemoved: (underlying: Underlying) => void;
  onUnderlyingsChanged: (underlyings: ReadonlyArray<Underlying>) => void;
};

export function Result({ underlyings, onUnderlyingRemoved, onUnderlyingsChanged }: Props) {
  const hasSomeEligibilityFlag = underlyings.some(u => isDefined(asEquityUnderlying(u)?.esgEligibility));
  const isInternal = useIsInternalUser();
  return (
    <ul className="list-group list-group-flush border-top border-opacity-40 pb-2">
      {underlyings.map(u => (
        <Row
          key={u.id}
          underlying={u}
          onClear={() => onUnderlyingRemoved(u)}
          onChangeUnderlyings={onUnderlyingsChanged}
          showEsgEligibilityFlag={hasSomeEligibilityFlag && isInternal}
        />
      ))}
    </ul>
  );
}
